export default {
  results: [],
  columns: [],
  headerColumns: [],
  parameters: {},
  selectedDeviceControl: [],
  isSelectAllChecked: false
};
